import { render, staticRenderFns } from "./SFormTypeProductComp.vue?vue&type=template&id=64c24235&"
import script from "./SFormTypeProductComp.vue?vue&type=script&lang=js&"
export * from "./SFormTypeProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports